export default __webpack_public_path__ + "static/media/Gloves of Crimson Slaughter.936d4ddb.jpg";